import { WeModApiClient } from './api-client';

const apiClient = new WeModApiClient(process.env.NEXT_PUBLIC_WEMOD_API_URL ?? '');

export interface AIPromptConfig {
    name: string;
    key: string;
    provider?: string;
    model: string;
    instructions: string;
    responseFormat: string;
    maxTokens: number;
    maxSteps?: number | null;
    timeoutSeconds?: number | null;
    temperature?: number | null;
}

export async function getAIPromptConfig(promptKey: string, titleId?: string): Promise<AIPromptConfig> {
    return apiClient.get<AIPromptConfig>('/v3/ai/prompt', {
        params: {
            key: promptKey,
            ...(titleId && { titleId }),
        },
    });
}
